module.exports = __webpack_public_path__ + "img/down-convex.977bb292.svg";